<template>
  <div :class="classes">
    <div v-if="hasScroll" :class="prveBtnClass" @click="handleScroll(false)">
      <i class="el-icon-caret-left"></i>
    </div>
    <div
      :class="containerClass"
      ref="container"
      v-touch:moving="mouseTouch ? movingHandler : null"
      v-touch:start="mouseTouch ? mouseHandler : null"
      v-touch:end="mouseTouch ? mouseHandler : null"
      @mouseleave="isMoving = false"
    >
      <div :class="contentClass" ref="content">
        <template v-for="(column, index) in columns">
          <div
            class="tg-amount-bar--item"
            :key="index"
            v-if="column.show != false"
          >
            <span>
              <template v-if="column.prefix"
                >{{ $t("column." + column.prefix) }}-</template
              >
              {{
                $t("column." + column.langKey, {
                  third_party: $t("column." + column.third_party),
                })
              }}
            </span>
            <span :class="parseValueClass(column)">
              {{ parseValue(column) }}
            </span>
          </div>
        </template>
      </div>
    </div>
    <div v-if="hasScroll" :class="nextBtnClass" @click="handleScroll(true)">
      <i class="el-icon-caret-right"></i>
    </div>
  </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
  data() {
    return {
      prefixCls: "tg-amount-bar",
      hasScroll: true,
      scrollX: 0,
      startX: 0,
      scrollLeft: 0,
      isMoving: false,
    };
  },
  props: {
    columns: Array,
    row: Object,
    mouseTouch: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  computed: {
    classes() {
      return [this.prefixCls + "--wrapper"];
    },
    prveBtnClass() {
      return [this.prefixCls + "--btn", "prev"];
    },
    contentClass() {
      return [this.prefixCls + "--content"];
    },
    nextBtnClass() {
      return [this.prefixCls + "--btn", "next"];
    },
    containerClass() {
      return [
        "tg-amount-bar--container",
        {
          "has-scroll": this.hasScroll,
          "has-grab": this.mouseTouch,
          "is-moving": this.isMoving,
        },
      ];
    },
  },
  mounted() {
    // this.parseScroll();
  },
  methods: {
    parseValueClass(column) {
      const value = this.row ? this.row[column.name] : 0;

      return {
        // 數值顏色(藍)
        value: !column.isAccounts,
        "text-green": column.isAccounts && value > 0,
        "text-red": column.isAccounts && value < 0,
      };
    },
    parseValue(column) {
      let value = this.row ? this.row[column.name] : "";

      if (
        "default" in column &&
        (typeof value == "undefined" ||
          null == value ||
          (typeof value == "string" && !value))
      ) {
        value = column.default;
      }

      if (column.format) {
        value = formatter.format(value, column.format);
      }

      return value;
    },
    handleScroll(isNext = true, fast = false) {
      let container = this.$refs.container;
      let base = fast ? 254 * 2 : 254;
      let scroll,
        doScroll = false;
      if (isNext) {
        scroll = container.scrollLeft + base;
        doScroll = scroll < container.scrollWidth;
      } else {
        scroll = container.scrollLeft - base;
        scroll = scroll < 0 ? 0 : scroll;
        doScroll = scroll >= 0;
      }
      if (doScroll) {
        container.scrollTo({
          top: 0,
          left: scroll,
          behavior: "smooth",
        });
        this.$emit("on-scroll", {
          target: container,
          scroll,
        });
      }
    },
    syncScrollX(scrollW, x) {
      let container = this.$refs.container;
      let w = container.scrollWidth;
      let sx = (x * w) / scrollW;
      container.scrollTo(sx, 0);
    },
    mouseHandler(e) {
      let isMoving = e.buttons == 1;
      this.isMoving = isMoving;

      if (isMoving) {
        this.startX = e.x;
        this.scrollX = this.$refs.container.scrollLeft;
      }
    },
    movingHandler(e) {
      if (this.isMoving) {
        let scroll = e.movementX;
        this.scrollX += -scroll;
      }
    },
    parseScroll() {
      let contentWidth = 64 + 254 * this.columns.length;
      let elWidth = this.$el.clientWidth;

      this.hasScroll = elWidth <= contentWidth;
    },
  },
  watch: {
    scrollX(val) {
      let container = this.$refs.container;
      container.scrollTo(val, 0);
    },
  },
};
</script>
